// Format: "5/18 14:39:23" -- 24h, no AM/PM, no year
export function formatTradeTime(d: Date | string | null | undefined): string {
  if (!d) return '--';
  const dt = typeof d === 'string' ? new Date(d) : d;
  if (isNaN(dt.getTime())) return '--';
  const M = dt.getMonth() + 1;
  const D = dt.getDate();
  const HH = String(dt.getHours()).padStart(2, '0');
  const mm = String(dt.getMinutes()).padStart(2, '0');
  const ss = String(dt.getSeconds()).padStart(2, '0');
  return `${M}/${D} ${HH}:${mm}:${ss}`;
}
